
















import JMessageArticleList from "@/general/components/pages/parts/ThanksPointList/JMessageArticleList.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    JMessageArticleList
  }
})
export default class J03AResultScreen extends Vue {
  @Prop({ type: Array, required: true }) resultArray!: any;
  @Prop({ type: Array, default: [] }) exclude!: any;
  @Prop({ type: [String, Boolean], required: true }) heading!: string | boolean;
  @Prop({ type: [Boolean, Number], default: false })
  messagesSearchResultsCount!: boolean | number;

  get itemCount() {
    return this.messagesSearchResultsCount;
  }

  get itemCountString() {
    const itemCount = this.itemCount;
    if (!itemCount) {
      return `（0件）`;
    }
    return `（${itemCount}件）`;
  }
}
